(function ClientSnapshot($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		var results_map;
		var map_rendered    = false;
		var charts_rendered = false;

		Adzuki.onload('/Clients/snapshot/', function onload() {
			$('.nav-tabs>li').click(function changeTab() {

				var $results_map,
					data,
					sales_data,
					comission_data;

				if ($(this).hasClass('active')) {
					return;
				}

				switch ($(this).data("type")) {
					case 'what':

						Adzuki.Ajax.get('/Clients/snapshotWhat/' + $(this).data("id"))
						.then(function populateWhat(content) {
							$('#what').html(content);

							sales_data  = $('#sales-chart').data("sales-data");
							comission_data  = $('#commission-chart').data("commission-data");

							if (!charts_rendered) {
								showCharts(sales_data, comission_data);
							}

						});
					break;
					case 'when':
						Adzuki.Ajax.get('/Clients/snapshotWhen/' + $(this).data("id"))
						.then(function populateWhen(content) {
							$('#when').html(content);
						});
					break;
					case 'where':
						Adzuki.Ajax.get('/Clients/snapshotWhere/' + $(this).data("id"))
						.then(function populateWhere(content) {
							$('#where').html(content);

							$results_map = $("#snapshot-map");
							data         = $results_map.data('results');

							if (!map_rendered) {
								showMap(data);
							}
						});
					break;
					default:
					break;
				}
			});
		});

		function showMap(data) {
			results_map  = new Adzuki.Map('#snapshot-map');
			results_map.populate(data.map);
			console.log(data.map);
		}

		function showCharts(sales_data, comission_data) {
			var chart           = new Adzuki.Chart('#sales-chart', {
					width : '100%',
					height: 400
				}),
				chart2          = new Adzuki.Chart('#commission-chart', {
					width : '100%',
					height: 400
				});

			chart.opts['title'] = "Sales % Breakdown By Component";
			chart.opts['is3D']  = true;

			$(chart).on('ready', function drawSalesChart() {
				chart.data.addColumn('string', 'Col1Label');
				chart.data.addColumn('number', 'Col1Data');
				chart.data.addRows(sales_data);

				chart.draw('pie');
			});

			chart2.opts['title'] = "Commission % Breakdown By Component";
			chart2.opts['is3D']  = true;

			$(chart2).on('ready', function drawCommissionChart() {
				chart2.data.addColumn('string', 'Col1Label');
				chart2.data.addColumn('number', 'Col1Data');
				chart2.data.addRows(comission_data);

				chart2.draw('pie');
			});

			// charts_rendered = true;
		}
	});
}(jQuery, window.Adzuki || {}));